// External library
import Glide from '@glidejs/glide'

// Component
export default class SliderContent {
    constructor () {
        this.sliders = document.querySelectorAll('[data-slider-content]') // content slider selector
        this.options = {
            type: 'carousel',
            breakpoints: {
                767: {
                    perView: 1
                }
            }
        }

        if (!this.sliders)
            return

        this.setupSliders()
    }

    setupSliders () {
        this.sliders.forEach(item => {
            const current = item.querySelector('.slider-content-nav-prog-current')
            const slides = item.querySelectorAll('.glide__slide')

            this.options.perView = item.dataset.sliderPerView || 1
            this.options.gap = this.options.perView > 1 ? 50 : 0

            const {
                sliderContent: totalString,
                sliderDuration,
                sliderTransition: transition
            } = item.dataset

            const total = +totalString

            if (sliderDuration)
                this.options.animationDuration = sliderDuration

            const glide = new Glide(item, this.options)
                .mount()

            if (transition && transition === 'fade' && slides)
                glide.on('run', (e) => {
                    const slideCss = {
                        enter: glide.index,
                        cssEnter: 'glide__slide--enter'
                    }

                    if (e.direction === '>') {
                        slideCss.cssLeave = 'glide__slide--active-left'
                        slideCss.leave = glide.index === 0
                            ? (total - 1)
                            : glide.index - 1
                    }

                    if (e.direction === '<') {
                        slideCss.cssLeave = 'glide__slide--active-right'
                        slideCss.leave = glide.index === (total - 1)
                            ? 0
                            : glide.index + 1
                    }

                    this.fadeIn(slides, slideCss)
                })

            glide.on('run.after', () => {
                if (current)
                    current.textContent = glide.index + 1
            })

            glide.on(
                'resize',
                () => glide.go('<<')
            )
        })
    }

    fadeIn (slides, settings) {
        const { leave, enter, cssLeave, cssEnter } = settings

        slides[leave].classList.add(cssLeave)
        slides[enter].classList.add(cssEnter)
    }
}
